import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: 'What age group do you teach?',
      answer: 'We teach 6–15 year olds. Writing Class begins at age 11.'
    },
    {
      question: 'Do you offer home-based or online classes?',
      answer: 'Both. Home-based classes every Sunday. Online classes on weekdays (based on teachers\' availability).'
    },
    {
      question: 'Do you accept beginners?',
      answer: 'We accept students age 6 and above. Every student begins with a Level Test to determine the correct placement.'
    },
    {
      question: 'How many students are in each class?',
      answer: 'Book Reading: Maximum 4–5 students. Writing Class: Maximum 6–8 students.'
    },
    {
      question: 'What materials do you use?',
      answer: 'Book Reading: curated storybooks, U.S. novel workbooks, Singapore vocabulary worksheets. Writing: National Geographic Reading Explorer + structured writing worksheets.'
    },
    {
      question: 'Is this suitable for Korean/Japanese/Chinese ESL students?',
      answer: 'Yes — we specialise in ESL learners from these backgrounds.'
    },
    {
      question: 'How do I enrol?',
      answer: 'Contact us to book a Free Level Test, and we will provide class times and availability.'
    },
    {
      question: 'What makes OHT unique?',
      answer: 'Our home-based environment, premium and standard class size options available, structured reading and writing system, mandatory vocabulary building, and focus on confidence and clarity. Premium classes offer more teacher focus with a maximum of 5 students only. Standard classes include a maximum of 12 students only.'
    },
    {
      question: 'Do you provide progress reports?',
      answer: 'Yes — students receive periodic academic feedback, twice a year.'
    },
    {
      question: 'How soon will my child improve?',
      answer: 'Most students show noticeable progress within 6 months, however this depends on their work, focus and consistency.'
    },
    {
      question: 'Do you offer trial classes?',
      answer: 'Yes — subject to availability.'
    },
    {
      question: 'Do you prepare students for exams or IGCSE?',
      answer: "We focus on building a strong English foundation so students can achieve true language success. Rather than teaching just for tests, we help students develop lasting skills in reading, writing, and expression that support both academic growth and real-world confidence. With a strong foundation in reading, writing, and clear expression, students naturally become prepared for school exams, IGCSE, and the bigger world beyond academics."
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-16 md:py-24 bg-gradient-to-b from-white to-[#F5F5DC]">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-3 mb-4">
            <i className="ri-question-answer-line text-4xl text-[#153223]"></i>
            <h2 className="font-['Yeseva_One',serif] text-4xl md:text-5xl text-[#153223]">
              Frequently Asked Questions
            </h2>
          </div>
          <p className="text-xl text-gray-700">
            Everything you need to know about OHT Tuition Academy
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow-md overflow-hidden transition-all duration-300 hover:shadow-lg"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-8 py-6 flex items-center justify-between gap-4 cursor-pointer text-left hover:bg-[#F5F1E8] transition-colors duration-300"
              >
                <h3 className="text-lg font-bold text-[#153223] flex-1">
                  {faq.question}
                </h3>
                <div className="w-8 h-8 flex items-center justify-center bg-[#153223] rounded-full flex-shrink-0">
                  <i
                    className={`ri-arrow-${openIndex === index ? 'up' : 'down'}-s-line text-xl text-[#FFE66D] transition-transform duration-300`}
                  ></i>
                </div>
              </button>

              <div
                className={`overflow-hidden transition-all duration-300 ${openIndex === index ? 'max-h-96' : 'max-h-0'}`}
              >
                <div className="px-8 pb-6 pt-2">
                  <p className="text-gray-700 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-gray-700 mb-4">Still have questions?</p>
          <a
            href="https://wa.link/zxuf0o"
            target="_blank"
            rel="noopener noreferrer"
            className="whitespace-nowrap bg-[#25D366] hover:bg-[#20BD5A] text-white font-bold px-8 py-4 rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer inline-flex items-center gap-2"
          >
            <i className="ri-whatsapp-line text-xl"></i>
            Contact Us
          </a>
        </div>
      </div>
    </section>
  );
}